import { render } from "./PostCategoryListView.vue?vue&type=template&id=a1033d76"
import script from "./PostCategoryListView.vue?vue&type=script&lang=js"
export * from "./PostCategoryListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__